import React, { useRef, useEffect } from 'react';
import { SliderWrapper } from 'jd-library';
import { useDispatch } from 'react-redux';
import { toggleSupportSlider } from '../../actions/products'
import styles from './support-slider.scss';
import { ProductAddIcon, ProductApproveIcon, ProductDeletionIcon, CatalogueIcon } from './SupportIcons';

const SupportSlider = props => {
    const dispatch = useDispatch();
    const supportSliderRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            const sliderInstance = supportSliderRef.current?.sliderRef?.current;
            if (sliderInstance?.sliderContentRef?.current) {
                const container = sliderInstance.sliderContentRef.current;
                const firstFocusable = container.querySelector('[tabindex="0"], button:not([disabled]), a[href]');
                if (firstFocusable) firstFocusable.focus();
            }
        }, 350);
        return () => clearTimeout(timer);
    }, []);

    return (
        <SliderWrapper
            ref={supportSliderRef}
            header={{
                heading: 'Help Center',
                leftIcons: [],
                rightIcons: [{
                    className: 'icon-HDRcross',
                    onClick: () => {
                        window.history.back();
                    }
                }]
            }}
            onHidden={() => dispatch(toggleSupportSlider({show: false}))}
            slider={{
                className: styles['support-slider'],
            }}
        >
            {/* <div className={styles['upper-sec']}>
                <CatalogueIcon />
                <div className={styles['info-txt']}>Please find your support options below</div>
            </div> */}
            <div className={styles['lower-sec']}>
                <a className={`${styles['video-link']}`} href="https://youtu.be/kNzxlhXdXW0" target={"_blank"} rel='noopener noreferrer'>
                    <ProductAddIcon />
                    <span>Watch Product Creation tutorial</span>
                </a>
                <a className={`${styles['video-link']}`} href="https://youtu.be/bkdvFxs9_CQ" target={"_blank"} rel='noopener noreferrer'>
                    <ProductApproveIcon />
                    <span>Watch Product Approval tutorial</span>
                </a>
                <a className={`${styles['video-link']}`} href="https://youtu.be/mnuNi2mTuAo" target={"_blank"} rel='noopener noreferrer'>
                    <ProductDeletionIcon />
                    <span>Watch Product Deletion tutorial</span>
                </a>
            </div>
        </SliderWrapper>
    )
};

export default SupportSlider;